<template>
  <div class="overflow-hidden position-relative mb-5 mb-md-7 mb-lg-8 slides">
    <LoadingWidget v-if="loading" />

    <transition name="fade">
      <div v-if="!loading && items.length">
        <hooper-container
          class="slides-container primary"
          style="height: auto"
          ref="carousel"
          :wheelControl="false"
          :mouseDrag="items.length > 1"
          :touchDrag="items.length > 1"
          :infiniteScroll="items.length > 1"
          @slide="updateCarousel"
        >
          <hooper-slide
            class="position-relative item"
            v-for="(
              { img_desktop, img_mobile, title, text, btn_text, btn_link },
              keySlide
            ) in items"
            :key="keySlide"
          >
            <img
              :src="
                files +
                (xs && img_mobile ? img_mobile : img_desktop) +
                '?resize=1&w=' +
                (xs ? 600 : 1920)
              "
              class="d-block item-img"
              width="100%"
            />

            <div
              v-if="title || text"
              class="d-flex align-center justify-center item-caption"
            >
              <v-container>
                <v-row>
                  <v-col
                    cols="12"
                    sm="10"
                    md="6"
                    lg="5"
                    class="position-relative item-caption-bg"
                  >
                    <div class="position-relative">
                      <div
                        class="
                          white--text
                          text-h5 text-md-h4 text-lg-h3
                          font-weight-medium
                          item-title
                        "
                      >
                        {{ title }}
                      </div>

                      <div class="mt-4 item-text">
                        <div
                          class="white--text text-body-1"
                          v-html="text"
                        ></div>
                      </div>

                      <ButtonWidget
                        v-if="btn_link"
                        class="mt-8"
                        :href="btn_link"
                      >
                        {{ btn_text || "Saiba Mais" }}
                      </ButtonWidget>
                    </div>
                  </v-col>
                </v-row>
              </v-container>
            </div>
          </hooper-slide>
        </hooper-container>

        <div
          v-if="items.length > 1"
          class="d-flex justify-space-between px-3 px-md-4 px-lg-5 slides-nav"
        >
          <a
            class="
              d-flex
              align-center
              justify-center
              elevation-2
              pr-1
              slides-nav-item
            "
            @click.prevent="slidePrev"
          >
            <v-icon color="primary" :size="xs ? 20 : 30">
              fa-angle-left
            </v-icon>
          </a>
          <a
            class="
              d-flex
              align-center
              justify-center
              elevation-2
              pl-1
              slides-nav-item
            "
            @click.prevent="slideNext"
          >
            <v-icon color="primary" :size="xs ? 20 : 30">
              fa-angle-right
            </v-icon>
          </a>
        </div>

        <div v-if="!xs" class="position-relative">
          <div
            class="animation"
            :style="{
              left: `${Math.floor(Math.random() * 14 + i) * i}vw`,
            }"
            v-for="i in totalFishs"
            :key="i"
          >
            <AnimationWidget
              class="fish"
              :style="{
                width: `${Math.floor(Math.random() * (22 - 11) + 11)}vw`,
              }"
              :animation="`jumping-fish-${i}`"
            />
          </div>
        </div>

        <div class="animation waves">
          <AnimationWidget animation="waves" />
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import LoadingWidget from "../widgets/LoadingWidget.vue";
import ButtonWidget from "../widgets/ButtonWidget.vue";
import AnimationWidget from "../widgets/AnimationWidget.vue";

const _config = {
  mod: "slides",
};

export default {
  data: () => ({
    loading: true,
    carouselData: 0,
  }),
  computed: {
    items() {
      return this.$rest(_config.mod).list;
    },
    xs() {
      return this.$vuetify.breakpoint.xsOnly;
    },
    totalFishs() {
      switch (this.$vuetify.breakpoint.name) {
        case "xl":
          return 14;
        case "lg":
          return 12;
        case "md":
          return 9;
        case "sm":
          return 6;
        default:
          return 4;
      }
    },
  },
  mounted() {
    this.$rest(_config.mod)
      .get()
      .then(() => (this.loading = false));
  },
  methods: {
    slidePrev() {
      this.$refs.carousel.slidePrev();
    },
    slideNext() {
      this.$refs.carousel.slideNext();
    },
    updateCarousel(payload) {
      this.myCarouselData = payload.currentSlide;
    },
  },
  watch: {
    carouselData() {
      this.$refs.carousel.slideTo(this.carouselData);
    },
  },
  components: {
    LoadingWidget,
    ButtonWidget,
    AnimationWidget,
  },
};
</script>

<style lang="scss" scoped>
.slides {
  aspect-ratio: 1920 / 880;

  @media screen and (max-width: 600px) {
    aspect-ratio: 600 / 600;
  }

  .slides-container::v-deep {
    ul,
    ol {
      padding: 0 !important;
    }
  }

  .item {
    &-img {
      aspect-ratio: 1920 / 880;
      object-fit: cover;
      -o-object-fit: cover;

      @media screen and (max-width: 600px) {
        aspect-ratio: 600 / 600;
      }
    }

    &-caption {
      bottom: 0;
      left: 0;
      position: absolute;
      right: 0;
      top: 0;

      &-bg {
        &:before {
          background-color: rgba(0, 0, 0, 0.2);
          bottom: 0;
          content: "";
          filter: blur(4px);
          left: 0;
          position: absolute;
          right: 0;
          top: 0;
        }
      }
    }

    &-title {
      text-shadow: 0 0 3px rgba(0, 0, 0, 0.2);
    }

    &-text {
      text-shadow: 0 0 3px rgba(0, 0, 0, 0.6);
    }
  }

  &-nav {
    height: 0;
    left: 0;
    margin-top: -25px;
    position: absolute;
    top: 50%;
    width: 100%;

    @media screen and (max-width: 600px) {
      margin-top: -20px;
    }

    &-item {
      background-color: #ffffff;
      border-radius: 50%;
      height: 50px;
      width: 50px;

      @media screen and (max-width: 600px) {
        height: 40px;
        width: 40px;
      }
    }
  }

  .animation {
    bottom: 0;
    pointer-events: none;
    position: absolute;

    &.waves {
      bottom: -30px;
      width: 110%;

      @media screen and (max-width: 960px) {
        bottom: -20px;
      }
    }

    .fish {
      aspect-ratio: 1 / 1;
      -webkit-transform: matrix(-1, 0, 0, 1, 0, 0);
      -moz-transform: matrix(-1, 0, 0, 1, 0, 0);
      -o-transform: matrix(-1, 0, 0, 1, 0, 0);
      transform: matrix(-1, 0, 0, 1, 0, 0);
    }
  }
}
</style>
